var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c(_vm.sign,{tag:"componet"}),_c('div',{staticClass:"tabs sale"},[_c('span',{class:_vm.mark==1?"order-select":"order",on:{"click":function($event){return _vm.change(1)}}},[_vm._v("订单")]),_c('span',{class:_vm.mark==2?"person-select":"person",on:{"click":function($event){return _vm.change(2)}}},[_vm._v("我的")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }